import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import CatalogObjectReference from '@square/dashboard-items-data/models/invoices/cart/catalog-object-reference';
import Enum from '@square/dashboard-utilities/utils/enum';
import NumberAsString from '@square/dashboard-items-data/models/attrs/number-as-string';
import LegacyMoney from '@square/dashboard-data/utils/legacy-money';
export const DiscountType = new Enum(['FIXED', 'VARIABLE_PERCENTAGE', 'VARIABLE_AMOUNT']);
export const ModifyTaxBasis = new Enum(['MODIFY_TAX_BASIS', 'DO_NOT_MODIFY_TAX_BASIS']);
export default ProtoBaseModel.extend({
  id: attr(String),
  name: attr(String),
  percentage: attr(NumberAsString),
  amount: attr(LegacyMoney),
  discountType: attr(DiscountType, {
    defaultValue: 'FIXED'
  }),
  discountText: null,
  catalogObjectReference: attr(CatalogObjectReference),
  modifyTaxBasis: attr(ModifyTaxBasis),
  maximumAmount: attr(LegacyMoney)
}).reopenClass({
  createFor(discount) {
    return this.create({
      id: discount.get('id'),
      name: discount.get('name'),
      percentage: discount.get('percentage'),
      amount: discount.get('amount'),
      discountType: discount.get('discountType'),
      discountText: discount.get('discountText'),
      catalogObjectReference: CatalogObjectReference.fromCatalogModel(discount),
      modifyTaxBasis: discount.get('modifyTaxBasis'),
      maximumAmount: discount.get('maximumAmount')
    });
  }
});